var map = {
	"./newsArticles_de_de.js": [
		56725,
		9,
		725
	],
	"./newsArticles_en_ca.js": [
		92238,
		9,
		238
	],
	"./newsArticles_en_gb.js": [
		64511,
		7,
		511
	],
	"./newsArticles_en_us.js": [
		48350,
		7,
		350
	],
	"./newsArticles_es_es.js": [
		92327,
		9,
		327
	],
	"./newsArticles_es_mx.js": [
		63386,
		7,
		386
	],
	"./newsArticles_fr_ca.js": [
		92127,
		7,
		127
	],
	"./newsArticles_fr_fr.js": [
		48911,
		7,
		911
	],
	"./newsArticles_nl_nl.js": [
		55959,
		7,
		959
	],
	"./newsArticles_tr_tr.js": [
		95395,
		7,
		395
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32485;
module.exports = webpackAsyncContext;